import { TIME } from '@shared/src/utils/time';

type CountdownOptions = {
  time_left: number;
  step: number;
};

export class Countdown {
  #time_left: number;
  #step: number;
  #prev_loop_call = 0;

  #interval: number | null = null;

  #on_time_change = (time_left: number) => {};

  constructor(options: CountdownOptions) {
    this.#time_left = options.time_left;
    this.#step = options.step;
  }

  get timeLeft() {
    return this.#time_left;
  }

  #loop = () => {
    const now = performance.now() | 0;

    const delta = now - this.#prev_loop_call;

    const newLeft = this.#time_left - delta;

    if (newLeft > 0) {
      this.#prev_loop_call = now;
      this.#time_left = newLeft;

      this.#on_time_change(newLeft);
    } else {
      this.stop();
    }
  };

  start = () => {
    if (this.#time_left > 0 && this.#interval === null) {
      this.#prev_loop_call = performance.now() | 0;

      this.#interval = window.setInterval(this.#loop, this.#step);
    }
  };

  pause = () => {
    if (this.#interval !== null) {
      window.clearInterval(this.#interval);

      this.#interval = null;
    }
  };

  stop = () => {
    this.pause();

    if (this.#time_left > 0) {
      this.#prev_loop_call = 0;
      this.#time_left = 0;

      this.#on_time_change(0);
    }
  };

  add_time = (time: number) => {
    this.#time_left += time;

    this.#time_left = Math.max(0, this.#time_left);

    this.#on_time_change(this.#time_left);
  };

  set_time = (time: number) => {
    this.#time_left = time;

    this.#time_left = Math.max(0, this.#time_left);

    this.#on_time_change(this.#time_left);
  };

  on_time_change = (callback: (time_left: number) => void) => {
    this.#on_time_change = callback;
  };
}
